import jump from 'jump.js';
import validate from '../../vendor/validate';
import validateDefaults from './validate-defaults';
import validateMatchValue from './validate-match-value';

export default function () {
  const form = document.querySelector('.js-form-validate');
  const settings = Object.assign({}, validateDefaults, {
    afterShowError: function (field) {
      if (!validationError) {
        validationError = field;

        // Jump to error
        if ( window.allowScroll ) {
          jump(validationError, {
            duration: 750,
            offset: -85,
          });
        }
      }
    },
    beforeSubmit: function () {
      validateMatchValue();
    }
  });

  if (!form) {
    return;
  }

  window.allowScroll = true;
  window.validationError = false;

  /**
   * Validate the form
   */
  validate.init(settings);
};
